import { Button, Modal, Form, Row, Col, Select, message } from "antd";
import { useEffect, useState } from "react";
import patchDataClaim from "../../../../services/patchDataClaim";

const { Option } = Select;

export default function UpdateApr({
  isVisible,
  selected,
  setVisible,
  refetch,
}: any) {
  const [isLoading] = useState(false);

  const [form] = Form.useForm();

  const onSubmit = async () => {
    const values = await form.getFieldsValue();

    const { aprLevel } = values;
    if (aprLevel === 0) {
      message.error("Approval Level must be 1 or 2");
      return;
    }

    const data = { aprLevel: aprLevel };
    const uri = `claim/claimers/${selected?._id}/update/level`;
    const response = await patchDataClaim(data, uri);
    if (response.success) {
      message.success("Updated Successfully");
      await refetch();
      form.resetFields();
      hideModal();
    } else {
      message.error(response.message);
    }
  };

  const hideModal = () => {
    setVisible(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="Create Approver"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="udateApr"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="udateApr"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <div className="mb-4">
          You are making
          <span className="text-green-700 font-bold mx-1">
            {selected?.name}
          </span>
          expense claim approver
        </div>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="aprLevel"
              label="Approval Level"
              initialValue={selected?.aprLevel}
              rules={[
                {
                  required: true,
                  message: "Please select approval level",
                },
              ]}
            >
              <Select
                defaultValue={selected?.aprLevel}
                placeholder="Approval Level"
              >
                <Option value={1}>Approver Level 1</Option>
                <Option value={2}>Approver Level 2</Option>
              </Select>
            </Form.Item>
          </Col>

          {/* <Divider title="OR" />
          <div className="flex justify-center items-center w-full">
            <button
              className="flex justify-center items-center p-1"
              onClick={() => setRevoked(!isRevoked)}
            >
              {isRevoked ? (
                <div className="w-6 h-6 border bg-green-500 flex justify-center items-center">
                  <AiOutlineCheck color="#FFFFFF" />
                </div>
              ) : (
                <div className="w-6 h-6 border"></div>
              )}
              <span className="ml-2">Revoke Approver Status</span>
            </button>
          </div> */}
        </Row>
      </Form>
    </Modal>
  );
}
